import { atcb_init } from 'add-to-calendar-button';

var VCA = VCA || {};

VCA.AddToCalendar = (function ($) {

    function init() {
        if ($('.dashboard-appts').length) {
            atcb_init();
        }

        if ($('.petpage-appts').length) {
            atcb_init();
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    VCA.AddToCalendar.init();
});